/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Previouspage1Inputs */

const id_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman sebelumnya`)
};

const ms_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman sebelumnya`)
};

const da_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige side`)
};

const de_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Seite`)
};

const en_us2_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous page`)
};

const es_es2_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página anterior`)
};

const es_mx2_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página anterior`)
};

const fil_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraang pahina`)
};

const fr_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page précédente`)
};

const it_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina precedente`)
};

const hu_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző oldal`)
};

const nl_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige pagina`)
};

const no_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige side`)
};

const pl_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednia strona`)
};

const pt_br2_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página anterior`)
};

const pt_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página anterior`)
};

const ro_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina anterioară`)
};

const fi_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen sivu`)
};

const sv_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående sida`)
};

const vi_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trước`)
};

const tr_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki sayfa`)
};

const cs_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí stránka`)
};

const bg_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишна страница`)
};

const ru_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущая страница`)
};

const uk_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попередня сторінка`)
};

const ar_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة السابقة`)
};

const hi_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला पृष्ठ`)
};

const th_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าก่อนหน้า`)
};

const ja_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のページ`)
};

const zh_cn2_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一页`)
};

const zh_hant1_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一頁`)
};

const ko_builds_comparison_previouspage1 = /** @type {(inputs: Builds_Comparison_Previouspage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 페이지`)
};

/**
* | output |
* | --- |
* | "Previous page" |
*
* @param {Builds_Comparison_Previouspage1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_previouspage1 = /** @type {((inputs?: Builds_Comparison_Previouspage1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Previouspage1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_previouspage1(inputs)
	if (locale === "ms") return ms_builds_comparison_previouspage1(inputs)
	if (locale === "da") return da_builds_comparison_previouspage1(inputs)
	if (locale === "de") return de_builds_comparison_previouspage1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_previouspage1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_previouspage1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_previouspage1(inputs)
	if (locale === "fil") return fil_builds_comparison_previouspage1(inputs)
	if (locale === "fr") return fr_builds_comparison_previouspage1(inputs)
	if (locale === "it") return it_builds_comparison_previouspage1(inputs)
	if (locale === "hu") return hu_builds_comparison_previouspage1(inputs)
	if (locale === "nl") return nl_builds_comparison_previouspage1(inputs)
	if (locale === "no") return no_builds_comparison_previouspage1(inputs)
	if (locale === "pl") return pl_builds_comparison_previouspage1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_previouspage1(inputs)
	if (locale === "pt") return pt_builds_comparison_previouspage1(inputs)
	if (locale === "ro") return ro_builds_comparison_previouspage1(inputs)
	if (locale === "fi") return fi_builds_comparison_previouspage1(inputs)
	if (locale === "sv") return sv_builds_comparison_previouspage1(inputs)
	if (locale === "vi") return vi_builds_comparison_previouspage1(inputs)
	if (locale === "tr") return tr_builds_comparison_previouspage1(inputs)
	if (locale === "cs") return cs_builds_comparison_previouspage1(inputs)
	if (locale === "bg") return bg_builds_comparison_previouspage1(inputs)
	if (locale === "ru") return ru_builds_comparison_previouspage1(inputs)
	if (locale === "uk") return uk_builds_comparison_previouspage1(inputs)
	if (locale === "ar") return ar_builds_comparison_previouspage1(inputs)
	if (locale === "hi") return hi_builds_comparison_previouspage1(inputs)
	if (locale === "th") return th_builds_comparison_previouspage1(inputs)
	if (locale === "ja") return ja_builds_comparison_previouspage1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_previouspage1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_previouspage1(inputs)
	return ko_builds_comparison_previouspage1(inputs)
});
export { builds_comparison_previouspage1 as "builds.comparison.previousPage" }